import React from "react";
import Routes from "./Routes";
import "./utils/firebase-diagnostics";

function App() {
  return (
    <Routes />
  );
}

export default App;
